import { CircleConfig } from 'konva/lib/shapes/Circle';
import { EllipseConfig } from 'konva/lib/shapes/Ellipse';
import { PathConfig } from 'konva/lib/shapes/Path';
import { RectConfig } from 'konva/lib/shapes/Rect';

export enum SVGShapeType {
  Path = 'path',
  Circle = 'circle',
  Rectangle = 'Rectangle',
  Ellipse = 'Ellipse',
}

interface SVGCustomConfigs {
  fillOpposite: boolean;
  hasStroke: boolean;
  // strokeOpposite: boolean;
}

export interface SVGCircle extends CircleConfig, Partial<SVGCustomConfigs> {
  type: SVGShapeType.Circle;
}

export interface SVGPath extends PathConfig, Partial<SVGCustomConfigs> {
  type: SVGShapeType.Path;
  d: string;
}

export interface SVGRectangle extends RectConfig, Partial<SVGCustomConfigs> {
  type: SVGShapeType.Rectangle;
}

export interface SVGEllipse
  extends Partial<EllipseConfig>,
    Partial<SVGCustomConfigs> {
  type: SVGShapeType.Ellipse;
}

export type SVGShape = SVGPath | SVGCircle | SVGRectangle | SVGEllipse;
export type SVGShapes = SVGShape[];

export interface SVGIconDetail {
  value: number | string;
  viewBoxSize: number;
  shapes: SVGShapes;
  // paths: SVGPath[];
}
export type SVGIconWithoutValue = Omit<SVGIconDetail, 'value'>;

export const createSVGPath = (
  d: string,
  config: Partial<SVGPath> = {}
): SVGPath => ({
  type: SVGShapeType.Path,
  d,
  ...config,
});

export const createSVGCircle = (config: Partial<SVGCircle>): SVGCircle => ({
  type: SVGShapeType.Circle,
  ...config,
});

export const createSVGRectangle = (
  config: Partial<SVGRectangle>
): SVGRectangle => ({
  type: SVGShapeType.Rectangle,
  ...config,
});

export const createSVGEllipse = (config: Partial<SVGEllipse>): SVGEllipse => ({
  type: SVGShapeType.Ellipse,
  ...config,
});
